import { MethodsEnum } from '../constants/enums'
import { AnyObject } from '../constants/types'
import { generatePath } from 'react-router'

type MakeRequestProps = {
  url: string
  method: keyof typeof MethodsEnum
  body?: AnyObject
  parameters?: AnyObject
  queries?: AnyObject
}

export const addQueries = (url: string, queries: AnyObject) => {
  const urlObj = new URL(url)
  for (const key in queries) {
    if (queries[key] !== null && queries[key] !== undefined) {
      urlObj.searchParams.append(key, queries[key])
    }
  }

  return urlObj.href
}

export const makeRequest = async ({
  url,
  body,
  method,
  parameters,
  queries,
}: MakeRequestProps) => {
  try {
    let resultUrl = url
    if (parameters) {
      resultUrl = generatePath(resultUrl, parameters)
    }

    if (queries) {
      resultUrl = addQueries(resultUrl, queries)
    }

    const settings = {
      method,
      headers: {
        'Content-type': 'application/json; charset=UTF-8',
        accept: 'application/json',
      },
      credentials: 'include',
    } as AnyObject

    if (body) {
      settings.body = JSON.stringify(body)
    }

    const responseJson = await fetch(resultUrl, settings)

    if (responseJson.ok) {
      const response = await responseJson.text()
      return response ? JSON.parse(response) : null
    }

    return Promise.reject(responseJson)
  } catch (err: any) {
    throw err
  }
}
